/* eslint-disable default-param-last */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import { Tooltip, Fade } from '@material-ui/core';

export default function ValidationLength(
  data,
  charactersCount,
  noTooltip,
  fontBold,
  maxWidth,
  tooltipText = '',
  process = '',
  className = "fontSizeDefault pl0",
  disablePortal = false,
  placement,
  fontSize // 👈 novo parâmetro
) {
  const baseStyle = {
    maxWidth: maxWidth || 'inherit',
    minWidth: maxWidth || 'inherit',
    border: 'none',
    fontWeight: fontBold ? 'bold' : 'inherit',
    fontSize: fontSize || 'inherit' // 👈 só aplica se vier
  };

  if (data?.length > charactersCount || process?.length > charactersCount) {
    return noTooltip ? (
      <td className="fontSizeDefault m0 p0" style={baseStyle} align="left">
        {`${data.substring(0, charactersCount)}...`}
      </td>
    ) : (
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        enterTouchDelay={0}
        title={tooltipText || `${data} ${process}`}
        disablePortal={disablePortal}
        placement={placement}
      >
        <td className="fontSizeDefault m0 p0" style={baseStyle} align="left">
          {`${data.substring(0, charactersCount)}...`}
        </td>
      </Tooltip>
    );
  }

  return (
    <td className={className || "fontSizeDefault pl0"} style={baseStyle} align="left">
      {data} {process}
    </td>
  );
}

